<i class="fa fa-info-circle ms-2 pointer" aria-hidden="true" [ngbTooltip]="tooltip || ''"></i>
